import DOMPurify from 'dompurify';

export const BomTable = (props: any) => {
  const { newColumns, newRows } = props;
  return (
    <table className="bom-datatable table table-striped table-hover order-column lightershadow dataTable no-footer">
      <colgroup>
        {newColumns.map((col: any) => (
          <col
            key={col.data}
            width={
              col.width
                ? typeof col.width === "number"
                  ? `${col.width}px`
                  : col.width
                : "auto"
            }
          />
        ))}
      </colgroup>
      <thead>
        <tr>
          {newColumns.map((col: any) => (
            <th style={{ width: col.width }} key={col.data}>
              {col.title}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {newRows.map((row: any) => (
          <tr key={row.rowKey}>
            {newColumns.map((col: any) => (
              <td
                className={col.numeric ? "numeric-cell" : ""}
                key={col.data}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(col.render(row[col.name], row)),
                }}
              />
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
